import { LLMContextProvider } from "./contexts/llm-context"
import { ChatProvider } from "./contexts/chat/ChatProvider"
import { RateLimitProvider } from "./contexts/RateLimitContext"
import { Toaster } from "./components/ui/sonner"
import { SkipLinks } from "./components/layout/SkipLinks"
import { useState, useEffect } from "react"
import { api } from "./lib/api-client"
import { BrowserRouter as Router, useLocation } from "react-router-dom"
import AppRoutes from "./AppRoutes"

import type { Docset } from "./types"



function App() {
  const [docsets, setDocsets] = useState<Docset[]>([])
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    const fetchDocsets = async () => {
      try {
        const data = await api.docsets.list()
        setDocsets(data.docsets)
      } catch (error) {
        console.error("Failed to fetch docsets in App:", error)
      }
    }
    fetchDocsets()
  }, [])

  const handleModalStateChange = (isOpen: boolean) => {
    setIsModalOpen(isOpen)
  }

  return (
    <LLMContextProvider>
      <SkipLinks />
      <Router>
        <RateLimitProvider>
          <AppWithRoute docsets={docsets} isModalOpen={isModalOpen} handleModalStateChange={handleModalStateChange} />
        </RateLimitProvider>
      </Router>
      <Toaster position="top-center"/>
    </LLMContextProvider>
  )
}

function AppWithRoute({ docsets, isModalOpen, handleModalStateChange }: {
  docsets: Docset[]
  isModalOpen: boolean
  handleModalStateChange: (isOpen: boolean) => void
}) {
  const location = useLocation()
  const pathSegments = location.pathname.split('/')
  const routeDocset = pathSegments[1] // /paximum -> paximum, /tourvisio -> tourvisio
  
  // Route'dan gelen docset geçerli mi kontrol et
  const isValidDocset = docsets.some(ds => ds.id === routeDocset)
  const initialDocset = isValidDocset ? routeDocset : "tourvisio"
  


  return (
    <ChatProvider 
      initialDocset={initialDocset}
      onDocsetChange={(oldDocset, newDocset) => {
        console.log(`Chat: Docset changed from ${oldDocset} to ${newDocset}`)
      }}
    >
      <AppRoutes
        docsets={docsets}
        isModalOpen={isModalOpen}
        handleModalStateChange={handleModalStateChange}
      />
    </ChatProvider>
  )
}

export default App